import React from 'react';
import './App.css';
import { HashRouter as Router } from 'react-router-dom';
import Routers from './routers/Routers';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import store, { persistor } from './store/store';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme/theme';
import { ToastContainer } from 'react-toastify';  
import 'react-toastify/dist/ReactToastify.css';    

 

function App() {
  return (
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ThemeProvider theme={theme}>
            <div className='h-screen w-screen overflow-y-auto overflow-x-hidden'>
              <Router>
                <Routers  />
              </Router>
              <ToastContainer
                position="top-right"       
                autoClose={6000}           
                hideProgressBar={false}    
                newestOnTop={true}        
                closeOnClick={true}        
                rtl={false}                
              />
            </div>
          </ThemeProvider>
        </PersistGate>
    </Provider>
  );
}

export default App;
